import { useEffect, useState } from 'react';
import { cn } from 'common/utils';
import { saveUserTopics } from 'service/user';
import useGlobalStore from 'store/global';
import useStore from 'store/timeline';

import { Button } from '../atoms/button';

interface TopicHeaderProps {
  topicName: string;
  postCount: number;
  className?: string;
  topicId: number;
  isFollow: boolean;
}

const TopicHeader = ({
  topicName,
  postCount,
  className,
  topicId,
  isFollow,
}: TopicHeaderProps) => {
  const currentUser = useStore((state) => state.currentUser);
  const showLogin = useGlobalStore((state) => state.showLogin);
  const [isFollowed, setIsFollowed] = useState(isFollow);
  const [isProcessing, setIsProcessing] = useState(false);
  useEffect(() => {
    setIsFollowed(isFollow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicId]);

  const handleFollowClick = async (isFollowed: boolean) => {
    if (isProcessing) return;
    setIsProcessing(true);
    if (isFollowed) {
      setIsFollowed(false);
    } else {
      setIsFollowed(true);
    }
    try {
      await saveUserTopics({
        topicIds: [topicId],
        isRemove: isFollowed,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        setIsProcessing(false);
      }, 1000);
    }
  };
  return (
    <div
      className={cn(
        'mb-5 rounded-2xl bg-white p-3 shadow-sm md:p-5',
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-pp-bg-tertiary text-lg font-semibold text-pp-text-secondary md:size-12 md:text-2xl">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="size-6"
            >
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
          </div>
          <div className="flex flex-col gap-1">
            <h1 className="my-0 text-lg font-bold leading-tight text-pp-text-primary md:text-2xl">
              {topicName}
            </h1>
            <div className="text-sm text-pp-text-secondary">
              {postCount?.toLocaleString()} 件の投稿
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <Button
            onClick={() => {
              if (currentUser) {
                void handleFollowClick(isFollowed);
              } else {
                showLogin({});
              }
            }}
            disabled={isProcessing}
            variant={isFollowed ? 'default' : 'defaultGreen'}
            className={cn(
              'rounded-full px-6 py-2 text-sm font-semibold text-white transition-all duration-200 disabled:cursor-not-allowed',
              isFollowed ? 'hover:opacity-70' : '',
            )}
          >
            {isFollowed ? 'フォロー中' : 'フォロー'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopicHeader;
